import { render, staticRenderFns } from "./journeyQuestionEditor.vue?vue&type=template&id=7265b82c&scoped=true&"
import script from "./journeyQuestionEditor.vue?vue&type=script&lang=js&"
export * from "./journeyQuestionEditor.vue?vue&type=script&lang=js&"
import style0 from "./journeyQuestionEditor.vue?vue&type=style&index=0&id=7265b82c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7265b82c",
  null
  
)

export default component.exports